const i = ".sl-input-group{display:flex;align-items:stretch;width:100%;background:var(--sl-input-group-bg,hsl(var(--sl-hsl-card)));border:1px solid var(--sl-input-group-border-color,hsl(var(--sl-hsl-border)));border-radius:var(--sl-input-group-border-radius,var(--sl-radius-md,0.5rem));overflow:hidden;transition:border-color var(--sl-transition-normal,200ms) ease,box-shadow var(--sl-transition-normal,200ms) ease}.sl-input-group--validating{border-color:var(--sl-input-group-focus-border-color,hsl(var(--sl-hsl-primary)));box-shadow:0 0 0 3px hsl(var(--sl-hsl-primary) / 0.2)}.sl-input-group--sm{--sl-input-group-padding:var(--sl-spacing-2,0.5rem)}.sl-input-group--lg{--sl-input-group-padding:var(--sl-spacing-6,1.5rem)}.sl-input-group__prepend,.sl-input-group__append{display:flex;align-items:center;justify-content:center;padding:0 var(--sl-input-group-padding,var(--sl-spacing-3,0.75rem));background:var(--sl-input-group-addon-bg,hsl(var(--sl-hsl-input)));color:var(--sl-input-group-addon-color,hsl(var(--sl-hsl-muted-foreground)));border-right:1px solid var(--sl-input-group-border-color,hsl(var(--sl-hsl-border)));font-size:0.875rem;white-space:nowrap;user-select:none}.sl-input-group__prepend--empty,.sl-input-group__append--empty{display:none}.sl-input-group__append{border-right:none;border-left:1px solid var(--sl-input-group-border-color,hsl(var(--sl-hsl-border)))}.sl-input-group__input{flex:1;min-width:0;display:flex;align-items:stretch;padding:0}.sl-input-group__input > slot::slotted(*){width:100%;--sl-hsl-border:0 0% 0% / 0;--sl-shadow-sm:none;--sl-radius-md:0}.sl-input-group__prepend > slot::slotted(*),.sl-input-group__append > slot::slotted(*){color:var(--sl-input-group-addon-color,hsl(var(--sl-hsl-muted-foreground)))}.sl-input-group-addon{display:flex;align-items:center;justify-content:center;height:100%;font-size:0.875rem;background:var(--sl-input-group-addon-bg,hsl(var(--sl-hsl-input)));color:var(--sl-input-group-addon-color,hsl(var(--sl-hsl-muted-foreground)))}@media (prefers-reduced-motion:reduce){.sl-input-group{transition:none}}";
class l extends HTMLElement {
  static get observedAttributes() {
    return ["size", "has-validation"];
  }
  constructor() {
    super(), this._shadow = this.attachShadow({ mode: "open" }), this._render();
  }
  attributeChangedCallback(t, s, e) {
    s !== e && this._render();
  }
  get size() {
    return this.getAttribute("size") || "md";
  }
  set size(t) {
    this.setAttribute("size", t);
  }
  get hasValidation() {
    return this.hasAttribute("has-validation");
  }
  set hasValidation(t) {
    t ? this.setAttribute("has-validation", "") : this.removeAttribute("has-validation");
  }
  _render() {
    const t = this.size !== "md" ? ` sl-input-group--${this.size}` : "", s = this.hasValidation ? " sl-input-group--validating" : "";
    this._shadow.innerHTML = `
      <style>${i}</style>
      <div class="sl-input-group${t}${s}">
        <div class="sl-input-group__prepend">
          <slot name="prepend"></slot>
        </div>
        <div class="sl-input-group__input">
          <slot></slot>
        </div>
        <div class="sl-input-group__append">
          <slot name="append"></slot>
        </div>
      </div>
    `, this._setupSlotVisibility("prepend"), this._setupSlotVisibility("append");
  }
  /**
   * Hide the prepend/append wrapper when its slot has no assigned nodes.
   */
  _setupSlotVisibility(t) {
    const s = this._shadow.querySelector(`slot[name="${t}"]`), e = this._shadow.querySelector(`.sl-input-group__${t}`);
    if (!s || !e) return;
    const r = () => {
      const n = s.assignedNodes({ flatten: !0 }).length === 0;
      e.classList.toggle(`sl-input-group__${t}--empty`, n);
    };
    s.addEventListener("slotchange", r), r();
  }
}
typeof customElements < "u" && !customElements.get("sl-input-group") && customElements.define("sl-input-group", l);
class p extends HTMLElement {
  static get observedAttributes() {
    return ["text"];
  }
  constructor() {
    super(), this._shadow = this.attachShadow({ mode: "open" }), this._render();
  }
  attributeChangedCallback(t, s, e) {
    s !== e && this._render();
  }
  get text() {
    return this.getAttribute("text") || "";
  }
  set text(t) {
    this.setAttribute("text", t);
  }
  _render() {
    const t = this.text || "<slot></slot>";
    this._shadow.innerHTML = `
      <style>${i}</style>
      <span class="sl-input-group-addon">${t}</span>
    `;
  }
}
typeof customElements < "u" && !customElements.get("sl-input-group-addon") && customElements.define("sl-input-group-addon", p);
export {
  p as SlInputGroupAddonElement,
  l as SlInputGroupElement
};
//# sourceMappingURL=sl-input-group.js.map
